import React from "react";
import Navbars from "../Components/navbar";
import Secone from "./secone";
import Sectwo from "./sectwo";
import Secthree from "./secthree";
import Footer from "../Components/Footer";


const Portfoliolink = () => {
    return(
        <>
        <Navbars />
        <Secone />
        <Sectwo />
        <Secthree />
        <Footer /> 
        
        </>
    )
}

export default Portfoliolink;